import { useState, useEffect } from "react";
import {
    saveIncomingPO,
    fetchCompanyCodes,
    fetchCustomers,
    fetchProjects,
    fetchItems,
    fetchResources,
    fetchVendors,
    fetchTaxCodes,
    fetchHSNCodes
} from "../../Api/IncomingPo";
import { fetchItemMasterValue } from "../../Api/serviceApiMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../../Components/Logo";
import { useAuth } from '../../Context/AuthContext';
import { useServiceContext } from '../../Context/MasterContext/ServiceContext'
import { useMasterDataContext } from '../../Context/masterDataContext';
import { saveServiceRequest } from "../../Api/serviceApiMaster";


const RequestService = () => {
    const { user } = useAuth();
    const { customerLoc,
        loadCustomerLocation } = useServiceContext();
    const { itemData,
        loadItems } = useMasterDataContext();
    const userId = localStorage.getItem("userId") || "5";
    const [customers, setCustomers] = useState([]);
    const [projects, setProjects] = useState([]);
    const [items, setItems] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [taxCodes, setTaxCodes] = useState([]);
    const [hsnCodes, setHsnCodes] = useState([]);

    const [loadingCompanyCodes, setLoadingCompanyCodes] = useState(false);
    const [loadingCustomers, setLoadingCustomers] = useState(false);
    const [loadingProjects, setLoadingProjects] = useState(false);
    const [loadingItems, setLoadingItems] = useState(false);
    const [loadingResources, setLoadingResources] = useState(false);
    const [loadingVendors, setLoadingVendors] = useState(false);
    const [loadingTaxCodes, setLoadingTaxCodes] = useState(false);
    const [loadingHsnCodes, setLoadingHsnCodes] = useState(false);

    const [poData, setPoData] = useState({
        customerCode: user?.customerId,
        customerLocationID: "",
        remarks: "",

        itemData: [{
            serviceType: "",
            dateTime: "",
            serviceData: "",
            hours: "",
            quantity: "",
            price: "",
            amount: "",
            taxType: "",
            cgst: "",
            sgst: "",
            igst: "",
            hsn: "",
            grandTotal: "",
        }]
    });

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();


    const calculatePriceSummary = () => {
        let totalBasePrice = 0;
        let totalTaxAmount = 0;
        let totalPrice = 0;
        let roundedTotalPrice = 0;
        let roundOff = 0;

        poData.itemData.forEach(item => {
            const quantity = parseFloat(item.quantity) || 0;
            const price = parseFloat(item.price) || 0;
            const cgst = parseFloat(item.cgst) || 0;
            const sgst = parseFloat(item.sgst) || 0;
            const igst = parseFloat(item.igst) || 0;

            const basePrice = quantity * price;
            const taxAmount = basePrice * ((cgst + sgst + igst) / 100);

            totalBasePrice += basePrice;
            totalTaxAmount += taxAmount;
            totalPrice += basePrice + taxAmount;
        });

        roundedTotalPrice = Math.round(totalPrice);
        roundOff = roundedTotalPrice - totalPrice;

        return {
            totalBasePrice: totalBasePrice.toFixed(2),
            totalTaxAmount: totalTaxAmount.toFixed(2),
            totalPrice: totalPrice.toFixed(2),
            roundedTotalPrice: roundedTotalPrice.toFixed(2),
            roundOff: roundOff.toFixed(2)
        };
    };

    const priceSummary = calculatePriceSummary();

    useEffect(() => {
        const loadData = async () => {
            setLoadingCompanyCodes(true);
            setLoadingCustomers(true);
            setLoadingProjects(true);
            setLoadingItems(true);
            setLoadingVendors(true);
            setLoadingTaxCodes(true);
            setLoadingHsnCodes(true);

            try {
                const [
                    companyCodesData,
                    customersData,
                    projectsData,
                    itemsData,
                    vendorsData,
                    taxCodesData,
                    hsnCodesData
                ] = await Promise.all([
                    fetchCompanyCodes(),
                    fetchCustomers(),
                    fetchProjects(),
                    fetchItems(),
                    fetchVendors(),
                    fetchTaxCodes(),
                    fetchHSNCodes()
                ]);

                setCustomers(customersData);
                setProjects(projectsData);
                setItems(itemsData);
                setVendors(vendorsData);
                setTaxCodes(taxCodesData);
                setHsnCodes(hsnCodesData);
            } catch (error) {
                toast.error("Failed to load data");
                console.error("Error loading data:", error);
            } finally {
                setLoadingCompanyCodes(false);
                setLoadingCustomers(false);
                setLoadingProjects(false);
                setLoadingItems(false);
                setLoadingVendors(false);
                setLoadingTaxCodes(false);
                setLoadingHsnCodes(false);
            }
        };

        loadData();
    }, []);

    console.log(customerLoc, 'customerLoc')


    const handleChange = (e) => {
        const { name, value } = e.target;
        setPoData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleItemChange = async (index, e) => {
        console.log(index, 'index')
        console.log(e.target.value, 'e', e.target.name)


        // return
        const { name, value } = e.target;
        const itemData = [...poData.itemData];

        const cleanedValue = ['amount', 'quantity', 'price', 'cgst', 'sgst', 'igst', 'grandTotal'].includes(name)
            ? value.replace(/[^0-9.]/g, '')
            : value;

        itemData[index] = {
            ...itemData[index],
            [name]: cleanedValue
        };


        if (['amount', 'quantity', 'price', 'cgst', 'sgst', 'igst'].includes(name)) {
            const quantity = parseFloat(itemData[index].quantity) || 0;
            const price = parseFloat(itemData[index].price) || 0;
            // const amount = parseFloat(itemData[index].amount) || 0;
            const cgst = parseFloat(itemData[index].cgst) || 0;
            const sgst = parseFloat(itemData[index].sgst) || 0;
            const igst = parseFloat(itemData[index].igst) || 0;

            const amount = price * quantity;
            const subtotal = quantity * price;
            const taxAmount = subtotal * ((cgst + sgst + igst) / 100);
            const grandTotal = subtotal + taxAmount;
            itemData[index].grandTotal = Math.round(grandTotal).toString();
        }

        setPoData({ ...poData, itemData });
        if (e.target.name === 'serviceData') {
            const res = await fetchItemMasterValue(e.target.value);
            // console.log(res, 'ress shvbf')
            itemData[index].price = res;

            // Now recalculate amount and grandTotal
            const quantity = parseFloat(itemData[index].quantity) || 0;
            const price = parseFloat(res) || 0;
            const cgst = parseFloat(itemData[index].cgst) || 0;
            const sgst = parseFloat(itemData[index].sgst) || 0;
            const igst = parseFloat(itemData[index].igst) || 0;

            const amount = price * quantity;
            const subtotal = amount;
            const taxAmount = subtotal * ((cgst + sgst + igst) / 100);
            const grandTotal = subtotal + taxAmount;

            itemData[index].amount = amount.toFixed(2);
            itemData[index].grandTotal = Math.round(grandTotal).toString();
        }

        // If quantity, price or tax is updated, recalculate
        if (['amount', 'quantity', 'price', 'cgst', 'sgst', 'igst', 'hours'].includes(name)) {
            const item = itemData[index];

            const quantity = parseFloat(itemData[index].quantity) || 0;
            const hours = parseFloat(itemData[index].hours) || 0;
            const price = parseFloat(itemData[index].price) || 0;
            const cgst = parseFloat(itemData[index].cgst) || 0;
            const sgst = parseFloat(itemData[index].sgst) || 0;
            const igst = parseFloat(itemData[index].igst) || 0;

            // 👇 Determine base amount based on type
            const isService = item.serviceType === "service";
            const baseValue = isService ? hours : quantity;

            const amount = price * baseValue;
            item.amount = amount.toFixed(2);

            const taxAmount = amount * ((cgst + sgst + igst) / 100);
            const grandTotal = amount + taxAmount;
            item.grandTotal = Math.round(grandTotal).toString();

            itemData[index] = item;
        }
        setPoData({ ...poData, itemData });
    };

    const handleTaxTypeChange = (index, e) => {
        const { value } = e.target;
        const itemData = [...poData.itemData];
        const selectedTax = taxCodes.find(tax => tax.code === value);

        if (selectedTax) {
            itemData[index] = {
                ...itemData[index],
                taxType: value,
                cgst: selectedTax.cgst?.toString() || "0",
                sgst: selectedTax.sgst?.toString() || "0",
                igst: selectedTax.igst?.toString() || "0"
            };

            const item = itemData[index];

            const quantity = parseFloat(item.quantity) || 0;
            const hours = parseFloat(item.hours) || 0;
            const price = parseFloat(item.price) || 0;
            const cgst = parseFloat(item.cgst) || 0;
            const sgst = parseFloat(item.sgst) || 0;
            const igst = parseFloat(item.igst) || 0;

            const isService = item.serviceType === "service";
            const baseValue = isService ? hours : quantity;

            const subtotal = baseValue * price;
            const taxAmount = subtotal * ((cgst + sgst + igst) / 100);
            const grandTotal = subtotal + taxAmount;

            itemData[index].amount = subtotal.toFixed(2);
            itemData[index].grandTotal = Math.round(grandTotal).toString();
        }

        setPoData({ ...poData, itemData });
    };


    const addNewItem = () => {
        setPoData({
            ...poData,
            itemData: [
                ...poData.itemData,
                {
                    serviceType: "",
                    dateTime: "",
                    serviceData: "",
                    hours: "",
                    quantity: "",
                    price: "",
                    taxType: "",
                    cgst: "",
                    sgst: "",
                    igst: "",
                    hsn: "",
                    grandTotal: "",
                }
            ]
        });
    };

    const removeItem = (index) => {
        if (poData.itemData.length === 1) {
            toast.warning("At least one item is required");
            return;
        }

        const itemData = [...poData.itemData];
        itemData.splice(index, 1);
        setPoData({ ...poData, itemData });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await saveServiceRequest(poData, user?.userId);
            // return
            toast.success(`🦄 Added Successfully`);

            // setPoData({})
            navigate("/services/customer-request-list");
        } catch (error) {
            toast.error("Failed to save document");
            console.error("Error details:", error.response?.data);
        } finally {
            setLoading(false);
        }
    };

    const isLoading = loading || loadingCompanyCodes || loadingCustomers ||
        loadingProjects || loadingItems || loadingResources ||
        loadingVendors || loadingTaxCodes || loadingHsnCodes;

    useEffect(() => {
        loadItems();
        loadCustomerLocation(user);
    }, []);

    return (
        <div className="main-content expand">
            <Container fluid className="fields-container">
                <h2 className="fields-title">Request Service</h2>

                {isLoading && (
                    <div className="loading-overlay">
                        <Sample14 />
                    </div>
                )}

                <Form onSubmit={handleSubmit} className="fields-form">
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Customer Location <span className="text-red">**</span></Form.Label>
                                <Form.Select
                                    name="customerLocationID"
                                    value={poData.customerLocationID}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Customer Loc.</option>
                                    {customerLoc.map((option) => (
                                        <option key={option?.locationID} value={option?.locationID}>
                                            {option?.locationID} - {option?.city} - {option?.postalCode}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                       
                       
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Remarks</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="remarks"
                                    value={poData.remarks}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>


                    <div className="item-data-section">
                        <h4 className="item-data-heading mb-3">Item Data</h4>

                        {poData.itemData.map((item, index) => (
                            <div key={index} className="item-data-container">
                                <div className="item-data-row">
                                    {/* Item */}
                                    <div className="item-data-field" style={{ width: '180px' }}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Select Type <span className="text-red">**</span></Form.Label>
                                            <Form.Select
                                                name="serviceType"
                                                value={item.serviceType}
                                                onChange={(e) => handleItemChange(index, e)}
                                                required
                                                disabled={loadingItems}
                                            >
                                                <option value="">Select Type</option>
                                                <option value="service">
                                                    Service
                                                </option>
                                                <option value="item">
                                                    Item
                                                </option>
                                            </Form.Select>
                                        </Form.Group>
                                    </div>

                                    <div className="item-data-field" style={{ width: '200px' }}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Service Date <span className="text-red">**</span></Form.Label>
                                            <Form.Control
                                                type="datetime-local"
                                                name="dateTime"
                                                value={item.dateTime || ""}
                                                onChange={(e) => handleItemChange(index, e)}
                                                required
                                            />
                                        </Form.Group>
                                    </div>

                                    {/* Resource */}
                                    <div className="item-data-field" style={{ width: '180px' }}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                {item.serviceType === "item" ? "Item Type" : item.serviceType === "service" ? "Service Type" : "Service/Item Type"}
                                            </Form.Label>
                                            <Form.Select
                                                name="serviceData"
                                                value={item.serviceData}
                                                onChange={(e) => handleItemChange(index, e)}
                                                disabled={loadingResources}
                                            >
                                                <option value="">Select Data</option>
                                                {itemData.map((option) => (
                                                    <option key={option.itemCodeId} value={option.itemCodeId}>
                                                        {option.itemCodeId} - {option.itemName}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </div>

                                    {item.serviceType === "service" && (
                                        <div className="item-data-field" style={{ width: '100px' }}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Hours <span className="text-red">**</span></Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    name="hours"
                                                    value={item.hours || ""}
                                                    onChange={(e) => handleItemChange(index, e)}
                                                    required
                                                />
                                            </Form.Group>
                                        </div>
                                    )}

                                    {item.serviceType === "item" && (
                                        <div className="item-data-field" style={{ width: '100px' }}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Qty <span className="text-red">**</span></Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="quantity"
                                                    value={item.quantity || ""}
                                                    onChange={(e) => handleItemChange(index, e)}
                                                    required
                                                />
                                            </Form.Group>
                                        </div>
                                    )}

                                    {/* Price */}
                                    <div className="item-data-field" style={{ width: '100px' }}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Price <span className="text-red">**</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="price"
                                                // value={priceValue}
                                                value={item.price || ""}
                                                onChange={(e) => handleItemChange(index, e)}
                                                // required
                                                readOnly
                                            />
                                        </Form.Group>
                                    </div>

                                    <div className="item-data-field" style={{ width: '100px' }}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Amount <span className="text-red">**</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="amount"
                                                value={item.amount}
                                                onChange={(e) => handleItemChange(index, e)}
                                                // required
                                                readOnly
                                            />
                                        </Form.Group>
                                    </div>

                                    <div className="item-data-field" style={{ width: '150px' }}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>HSN <span className="text-red">**</span></Form.Label>
                                            <Form.Select
                                                name="hsn"
                                                value={item.hsn}
                                                onChange={(e) => handleItemChange(index, e)}
                                                required
                                                disabled={loadingHsnCodes}
                                            >
                                                <option value="">Select HSN</option>
                                                {hsnCodes.map((hsn) => (
                                                    <option key={hsn.code} value={hsn.code}>
                                                        {hsn.code} - {hsn.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </div>

                                    {/* Tax Type */}
                                    <div className="item-data-field" style={{ width: '200px' }}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tax Code <span className="text-red">**</span></Form.Label>
                                            <Form.Select
                                                name="taxType"
                                                value={item.taxType}
                                                onChange={(e) => handleTaxTypeChange(index, e)}
                                                required
                                                disabled={loadingTaxCodes}
                                            >
                                                <option value="">Select Tax Code</option>
                                                {taxCodes.map((tax) => (
                                                    <option key={tax.code} value={tax.code}>
                                                        {tax.code} - {tax.description} - {tax.type}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </div>

                                    {/* CGST */}
                                    <div className="item-data-field" style={{ width: '80px' }}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>CGST %</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="cgst"
                                                value={item.cgst}
                                                onChange={(e) => handleItemChange(index, e)}
                                                readOnly
                                            />
                                        </Form.Group>
                                    </div>

                                    {/* SGST */}
                                    <div className="item-data-field" style={{ width: '80px' }}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>SGST %</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="sgst"
                                                value={item.sgst}
                                                onChange={(e) => handleItemChange(index, e)}
                                                readOnly
                                            />
                                        </Form.Group>
                                    </div>

                                    {/* IGST */}
                                    <div className="item-data-field" style={{ width: '80px' }}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>IGST %</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="igst"
                                                value={item.igst}
                                                onChange={(e) => handleItemChange(index, e)}
                                                readOnly
                                            />
                                        </Form.Group>
                                    </div>

                                    {/* HSN */}


                                    {/* Grand Total */}
                                    <div className="item-data-field" style={{ width: '120px' }}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Grand Total</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="grandTotal"
                                                value={item.grandTotal}
                                                readOnly
                                            />
                                        </Form.Group>
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="item-data-field" style={{ width: '150px' }}>
                                        <div className="d-flex gap-2 mb-3">
                                            <Button
                                                variant="danger"
                                                onClick={() => removeItem(index)}
                                                className="item-action-btn"
                                                disabled={poData.itemData.length === 1}
                                            >
                                                Remove
                                            </Button>
                                            {index === poData.itemData.length - 1 && (
                                                <Button
                                                    variant="success"
                                                    onClick={addNewItem}
                                                    className="item-action-btn"
                                                >
                                                    Add
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="fields-btn-container">
                        <Button
                            variant="primary"
                            type="submit"
                            className="fields-submit"
                            disabled={isLoading}
                        >
                            {loading ? "Saving..." : "Save Document"}
                        </Button>
                    </div>
                </Form>
            </Container>
        </div>
    );
};

export default RequestService;